export var MentionSharedCssClassName = {
  MENTION_CONTAINER: 'mentionView-content-wrap'
};